// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"76b4da52","455":"ed68491b"}[chunkId] + ".chunk.js";
};